import React from "react";
import HeroVideo1 from "../components/HeroVideo1";
import ImageText2 from "../components/Imagetext2";

import video from "../assets/videos/exhaustcontrol1.mp4";
import imageurl1 from "../assets/images/exhaustcontrol1.png";
import video2 from "../assets/videos/service2.mp4";
function ExhaustControl() {
  const text1 = (
    <>
      <p className="text-white text-lg">
        Exhaust Flap Control geeft u meer controle over het geluid van uw auto.
        Vertrek je op een rustige vroege ochtend en wil je niet iedereen om je
        heen wakker maken of wil je juist jouw aanwezigheid kenbaar maken?
      </p>
      <br />
      <p className="text-white text-lg">
        Met deze bedieningsfunctie kunt u in alle situaties zonder compromissen
        dezelfde auto gebruiken. Het stelt u in staat om het openen en sluiten
        van de uitlaatklep te veranderen en zogemakkelijk te kiezen tussen
        ingetogen gegorgel van de motor of beestachtig gebrul, afhankelijk van
        de gelegenheid waarin u zich bevindt.
      </p>
      <br />
      <p className="text-white text-lg">
        Wanneer de uitlaatklep gesloten is, staat de uitlaat in de meer stille
        modus. Wanneer u echter de klep opent, wordt de doorstroming op geen
        enkele manier belemmerd en staat de uitlaat in de meest agressieve
        brullende modus.
      </p>
    </>
  );
  return (
    <div>
      <HeroVideo1 videoSource={video} heading="EXHAUST FLAP CONTROL" />
      <ImageText2
        text={text1}
        imageUrl={imageurl1}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <HeroVideo1
        videoSource={video2}
        heading="Benieuwd welke services er beschikbaar zijn voor uw auto?Kies uw auto voor de beschikbare services of klik hier om contact met ons op te nemen!"
        buttontext="Zoek uw optimalisatie"
        buttonlink="/contact-us"
      />
    </div>
  );
}

export default ExhaustControl;
